"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatasetDistributorIndexingTask = void 0;
const routes_1 = require("../../routes");
const getDatasetDistributorIndexingTask = (client) => async (options) => {
    const { indexName, distributorId, productId } = options;
    const queryParams = new URLSearchParams();
    if (indexName) {
        queryParams.append('index_name', indexName);
    }
    if (productId) {
        queryParams.append('product_id', productId);
    }
    const url = `${routes_1.ENDPOINTS.GET_DATASET_PARTNER_INDEXING_TASK.applyParams(distributorId)}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const { data } = await client.get(url);
    return data;
};
exports.getDatasetDistributorIndexingTask = getDatasetDistributorIndexingTask;
